/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonHomeTotalTrxCountInfo = {
    TRXTP: BabylonHomeTotalTrxCountInfo.TRXTP;
    TTRXCNT: string;
};

export namespace BabylonHomeTotalTrxCountInfo {

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
    }


}

